import yup from 'src/libraries/validator.library';

const RopeTypeShape = {
  ropeType: yup.string().required(),
  ropeId: yup.number(),
};

export const RopeTypeSizeSchema = yup
  .object()
  .shape({
    ...RopeTypeShape,
  })
  .defined();

export const RopeTypeSchema = yup
  .object({
    ropeType: yup
      .object({
        count: yup.number(),
        rows: yup
          .array()
          .of(
            yup
              .object()
              .shape({
                ...RopeTypeShape,
              })
              .defined()
          )
          .defined(),
      })
      .defined(),
  })
  .defined();

export const RopeTypeFormSchema = yup
  .object()
  .shape({
    ...RopeTypeShape,
  })
  .defined();

export const RopeTypeResponsePayloadSchema = yup
  .object({
    ropeType: yup
      .object({
        ropeId: yup.number(),
        ropeType: yup.string(),
      })
      .defined(),
  })
  .defined();

export type IRopeTypeSize = yup.InferType<typeof RopeTypeSizeSchema>;
export type IRopeType = yup.InferType<typeof RopeTypeSchema>;
export type IRopeTypeForm = yup.InferType<typeof RopeTypeFormSchema>;
